import { useEffect, useState } from "react";
import { LogoMark } from "./icons";
import type { Theme } from "./theme";

export type NavFullProps = {
  theme: Theme;
  signInUrl: string;
  currentUser: { name: string; appUrl: string } | null;
};

export function NavFull({ theme, signInUrl, currentUser }: NavFullProps) {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <nav
      style={{
        position: "sticky",
        top: 0,
        zIndex: 50,
        borderBottom: `1px solid ${scrolled ? theme.border : "transparent"}`,
        background: scrolled ? `${theme.bg}e6` : "transparent",
        backdropFilter: scrolled ? "blur(12px)" : "none",
        WebkitBackdropFilter: scrolled ? "blur(12px)" : "none",
        transition: "all .25s ease",
      }}
    >
      <div
        style={{
          maxWidth: 1200,
          margin: "0 auto",
          padding: "14px 40px",
          display: "flex",
          alignItems: "center",
          gap: 40,
        }}
      >
        <a
          href="/marketing"
          style={{
            display: "flex",
            alignItems: "center",
            gap: 10,
            fontWeight: 600,
            fontSize: 17,
            letterSpacing: -0.3,
            color: theme.fg,
            textDecoration: "none",
          }}
        >
          <LogoMark theme={theme} size={22} />
          Rarion
        </a>
        <div
          style={{
            display: "flex",
            gap: 28,
            fontSize: 14,
            color: theme.fgMute,
          }}
          className="rarion-nav-links"
        >
          <a href="#what" style={{ color: "inherit", textDecoration: "none" }}>
            What Rarion does
          </a>
          <a href="#how" style={{ color: "inherit", textDecoration: "none" }}>
            How it works
          </a>
          <a href="#ai" style={{ color: "inherit", textDecoration: "none" }}>
            AI
          </a>
        </div>
        <div style={{ flex: 1 }} />
        {currentUser ? (
          <a
            href={currentUser.appUrl}
            style={{
              fontSize: 14,
              fontWeight: 500,
              padding: "8px 14px",
              borderRadius: theme.radius,
              background: theme.accent,
              color: theme.onAccent,
              textDecoration: "none",
            }}
          >
            Open Rarion
          </a>
        ) : (
          <a href={signInUrl} style={{ fontSize: 14, color: theme.fgMute, textDecoration: "none" }}>
            Sign in
          </a>
        )}
      </div>
    </nav>
  );
}
